/* BRAND theme — interacciones (marquee, header glass, slider, popup IG, PDP) */
(function () {
  // ---- Header: glass al hacer scroll (solo cuando está "over-hero" en la home) ----
  const header = document.querySelector('.site-header');
  if (header && header.classList.contains('over-hero')) {
    const onScroll = () => {
      if (window.scrollY > 40) { header.classList.remove('over-hero'); header.classList.add('glass'); }
      else { header.classList.add('over-hero'); header.classList.remove('glass'); }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // ---- Sets slider: flechas ----
  document.querySelectorAll('[data-slider]').forEach((wrap) => {
    const track = wrap.querySelector('.slider');
    wrap.querySelectorAll('[data-slider-dir]').forEach((btn) => {
      btn.addEventListener('click', () => {
        track.scrollBy({ left: (btn.dataset.sliderDir === 'next' ? 1 : -1) * track.clientWidth * 0.85, behavior: 'smooth' });
      });
    });
  });

  // ---- Instagram popup ----
  const modal = document.querySelector('#ig-modal');
  if (modal) {
    const fill = (cell) => {
      const d = cell.dataset;
      modal.querySelector('[data-ig-photo]').src = d.photo;
      modal.querySelector('[data-ig-caption]').textContent = d.caption || '';
      modal.querySelector('[data-ig-likes]').textContent = d.likes || '';
      modal.querySelector('[data-ig-comments]').textContent = d.comments || '';
      modal.querySelector('[data-ig-date]').textContent = d.date || '';
      const pill = modal.querySelector('[data-ig-pill]');
      pill.href = d.href || '#';
      pill.querySelector('[data-ig-pill-img]').src = d.photo;
      pill.querySelector('[data-ig-pill-name]').textContent = d.product || '';
      pill.querySelector('[data-ig-pill-price]').textContent = d.price || '';
    };
    document.querySelectorAll('[data-ig-cell]').forEach((cell) => {
      cell.addEventListener('click', () => { fill(cell); modal.classList.add('open'); document.body.style.overflow = 'hidden'; });
    });
    const close = () => { modal.classList.remove('open'); document.body.style.overflow = ''; };
    modal.querySelector('[data-ig-close]').addEventListener('click', close);
    modal.querySelector('.ig-modal__backdrop').addEventListener('click', close);
  }

  // ---- PDP: galería (thumbnails) ----
  const main = document.querySelector('[data-pdp-main]');
  if (main) {
    document.querySelectorAll('[data-pdp-thumb]').forEach((t) => {
      t.addEventListener('click', () => {
        main.src = t.dataset.full;
        document.querySelectorAll('[data-pdp-thumb]').forEach((x) => x.classList.remove('active'));
        t.classList.add('active');
      });
    });
  }

  // ---- PDP: selección de talla (top / única) ----
  document.querySelectorAll('[data-size-group]').forEach((group) => {
    const form = group.closest('form');
    const hidden = form ? form.querySelector('[data-variant-input]') : group.parentElement.querySelector('[data-variant-input]');
    const propTop = form ? form.querySelector('[data-prop-top]') : null;
    group.querySelectorAll('.size-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.size-pill').forEach((p) => p.classList.remove('active'));
        pill.classList.add('active');
        if (hidden) hidden.value = pill.dataset.variantId || '';
        if (propTop && pill.dataset.topSize) propTop.value = pill.dataset.topSize;
      });
    });
  });

  // ---- PDP: selección de talla inferior (Sets) ----
  document.querySelectorAll('[data-bottom-size-group]').forEach((group) => {
    const form = group.closest('form');
    const propBottom = form ? form.querySelector('[data-prop-bottom]') : null;
    group.querySelectorAll('.size-pill').forEach((pill) => {
      pill.addEventListener('click', () => {
        group.querySelectorAll('.size-pill').forEach((p) => p.classList.remove('active'));
        pill.classList.add('active');
        if (propBottom && pill.dataset.bottomSize) propBottom.value = pill.dataset.bottomSize;
      });
    });
  });

  // ---- PDP: modo de Set (Full / Top only / Bottom only) ----
  document.querySelectorAll('[data-set-mode]').forEach((sel) => {
    const topG = document.getElementById('size-group-top');
    const botG = document.getElementById('size-group-bottom');
    const priceEl = document.querySelector('.pdp__price');
    const addBtn = document.querySelector('.pdp__cta .btn-primary');
    function setMode(mode, btn) {
      sel.querySelectorAll('.set-mode-btn').forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');
      if (topG) topG.classList.toggle('hidden', mode === 'bottom');
      if (botG) botG.classList.toggle('hidden', mode === 'top');
      if (priceEl) priceEl.textContent = btn.dataset.price;
      if (addBtn) addBtn.textContent = 'Add to Cart — ' + btn.dataset.price;
    }
    sel.querySelectorAll('.set-mode-btn').forEach((b) => b.addEventListener('click', () => setMode(b.dataset.mode, b)));
  });

  // ---- Arrastre horizontal con el ratón (PC): SOLO mientras se mantiene el clic ----
  function dragScroll(track) {
    if (!track || track.dataset.dragInit) return;
    track.dataset.dragInit = '1';
    let down = false, startX = 0, startScroll = 0, moved = false, pid = null;
    track.querySelectorAll('img,a').forEach((el) => el.setAttribute('draggable', 'false'));
    const stop = () => {
      if (!down) return;
      down = false; track.classList.remove('is-dragging');
      try { if (pid !== null) track.releasePointerCapture(pid); } catch (e) {}
      pid = null;
    };
    track.addEventListener('pointerdown', (e) => {
      if (e.button !== undefined && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startScroll = track.scrollLeft; pid = e.pointerId;
      try { track.setPointerCapture(e.pointerId); } catch (er) {}
      track.classList.add('is-dragging'); e.preventDefault();
    });
    track.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 4) moved = true;
      track.scrollLeft = startScroll - dx;
    });
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((ev) => track.addEventListener(ev, stop));
    window.addEventListener('pointerup', stop);
    track.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  }
  window.GZ_dragScroll = dragScroll;
  document.querySelectorAll('.slider, .pdp-rec__track, .cart-rec__track, .insta-track').forEach(dragScroll);
})();
